import { RequestData } from '@ant-design/pro-table';
import { request } from '@/utils/request';

export interface CurrencyListItem {
  type: string;
  name: string;
  sequence: number;
  memoSupported: boolean;
  displayDecimal: number;
}

export interface ChainListItem {
  asset: string;
  chain: string;
  fireblocksAssetId: string;
  chainStatus: string;
}

export async function queryCurrencies(params: any): Promise<RequestData<CurrencyListItem>> {
  const data = await request<RequestData<CurrencyListItem>>('/currencies', {
    params
  });
  return data;
}

export async function queryChains(): Promise<ChainListItem[]> {
  const data = await request<ChainListItem[]>('/currencies/chains', { method: 'GET' });
  return data;
}
